module.exports = __webpack_public_path__ + "img/ic-shevron-left.82dd3a46.svg";